import { Injectable } from "@angular/core";
import { InstanceModel } from "../model/instance.model";
import { ResourceService } from "./resource.service";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { ProcessModel } from "../model/process.model";
import { map } from "rxjs/operators";
import { GlobalSettings } from "../model/settings.model";
import { AuthenticationService } from "./auth.service";
import { AttributeModel } from "../main/dynamic/model/attribute.model";
import { AttributeService } from "../main/dynamic/service/attribute.service";

@Injectable({
    providedIn: 'root'
})
export class MotorPolicyService extends ResourceService<ProcessModel> {

    private instance: InstanceModel


    constructor(
        http: HttpClient,
        settings: GlobalSettings,
        authService: AuthenticationService
        ) {
            super(http, "motor/Policies", settings.motorUrl, authService)
    }
}
